export default {
    props: {
        bulletPointsEnabled: {
            type: Boolean,
            default: false,
        },
        bulletPoints: {
            type: Array,
            default: () => [],
        },
    }
};
